
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import RaceModalities from './components/RaceModalities';
import Highlights from './components/Highlights';
import TracksSection from './components/TracksSection';
import LocationSection from './components/LocationSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <RaceModalities />
      <Highlights />
      <TracksSection />
      <LocationSection />
      <Footer />
    </div>
  );
}
